import React, { ReactNode, useCallback } from "react"
import { Button, useTheme } from "matsuri-ui"
import { css } from "@emotion/react"
import ArrowBackIcon from "@mui/icons-material/ArrowBackIosNew"
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIos"

export interface MobileAppHeaderProps extends Omit<
    React.HTMLAttributes<HTMLElement>,
    "title" | "color"
> {
    title?: React.ReactNode
    onPrev?: (event: React.SyntheticEvent<HTMLButtonElement>) => void
    onNext?: (event: React.SyntheticEvent<HTMLButtonElement>) => void
    nextIcon?: ReactNode
    children?: React.ReactNode
}

export const MobileAppHeader = ({
    children,
    className,
    title,
    onPrev,
    onNext,
    nextIcon = <ArrowForwardIcon />,
    ...props
}: MobileAppHeaderProps) => {
    const theme = useTheme()
    const disabledPrev = !onPrev
    const disabledNext = !onNext

    const handlePrev = useCallback(
        (event: React.SyntheticEvent<HTMLButtonElement>) => {
            if (onPrev) {
                onPrev(event)
            }
        },
        [onPrev]
    )

    const handleNext = useCallback(
        (event: React.SyntheticEvent<HTMLButtonElement>) => {
            if (onNext) {
                onNext(event)
            }
        },
        [onNext]
    )

    return (
        <header
            className={className}
            css={css`
                box-sizing: border-box;
                width: 100%;
            `}
            {...props}
        >
            <div
                css={css`
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding: ${theme.spacing}px ${theme.spacing * 2}px;
                `}
            >
                <Button
                    onClick={handlePrev}
                    icon={<ArrowBackIcon />}
                    rounded
                    css={
                        disabledPrev
                            ? css`
                                  z-index: 1;
                                  opacity: 0;
                              `
                            : undefined
                    }
                />
                {title}
                <Button
                    onClick={handleNext}
                    icon={nextIcon}
                    rounded
                    css={
                        disabledNext
                            ? css`
                                  z-index: 1;
                                  opacity: 0;
                              `
                            : undefined
                    }
                />
            </div>
            {children}
        </header>
    )
}
